import React, { useState, useEffect, useRef } from "react";
import InputMask from "react-input-mask";
import { Grid, GridColumn, Popup, Radio, Select } from "semantic-ui-react";
import { isValidForm, receiverTypeOptions, updateDataToObj } from "..";
import { isPatternValid } from "../../../_utilities/validation";
import {
	IForm,
	IFormValidation,
	IRepresentative,
	IRepresentativeValidation,
} from "../types";

export const StepOne = (props) => {
	const { inputData, saveData, nextStep, validationData, saveValidationData } =
		props;
	const [outputData, setOutputData] = useState<IForm>(inputData);
	const [valData, setValData] = useState<IFormValidation>(validationData);
	const [isValid, setIsValid] = useState<boolean>(false);

	const inputChange = (path, value, index = -1, extraKey = "") => {
		const tempData = updateDataToObj(outputData, path, value, index, extraKey);
		setOutputData({ ...tempData });
	};

	const inputBlur = (element, path, index = -1, extraKey = "") => {
		const tempVal = updateDataToObj(
			valData,
			path,
			isPatternValid(element.getAttribute("data-pattern"), element.value),
			index,
			extraKey
		);
		setValData({ ...tempVal });
	};

	const addRepresentative = () => {
		let tempData: IForm = outputData;
		const newRep: IRepresentative = {
			representativeName: "",
			representativeSurname: "",
			representativeID: "",
			representativePesel: "",
			representativePhone: "",
		};
		tempData.receiver.receiverRepresentatives.push(newRep);
		setOutputData({ ...tempData });

		let tempVal: IFormValidation = valData;
		const newRepValidation: IRepresentativeValidation = {
			representativeName: undefined,
			representativeSurname: undefined,
			representativeID: undefined,
			representativePesel: undefined,
			representativePhone: undefined,
		};
		tempVal.receiver.receiverRepresentatives.push(newRepValidation);
		setValData({ ...tempVal });
	};

	const removeRepresentative = () => {
		let tempData: IForm = outputData;
		tempData.receiver.receiverRepresentatives.pop();
		setOutputData({ ...tempData });

		let tempVal: IFormValidation = valData;
		tempVal.receiver.receiverRepresentatives.pop();
		setValData({ ...tempVal });
	};

	const handleRadioChange = (e, { value }, fieldPath: string) => {
		let tempData: IForm = { ...outputData };

		// Funkcja do ustawiania wartości wg ścieżki
		const setNestedValue = (obj, path, value) => {
			const keys = path.split(".");
			const lastKey = keys.pop();
			const deepObj = keys.reduce((o, k) => o[k], obj);
			deepObj[lastKey] = value;
		};

		setNestedValue(tempData, fieldPath, value === "true");

		setOutputData(tempData);
	};

	const formRef = useRef(null);
	const formSubmit = (e) => {
		e.preventDefault();
		saveData({ ...outputData });
		saveValidationData({ ...valData });
		nextStep(2);
	};

	useEffect(() => {
		setIsValid(isValidForm(formRef.current));
	}, [outputData, valData]);

	return (
		<div className="m-form__step">
			<h2 className="m-form__header">Dane Wnioskującego</h2>
			<form onSubmit={formSubmit} ref={formRef}>
				<div className="m-form__block">
					<h3 className="m-form__subheader with-tooltip">
						<span>Wnioskujący</span>
						<Popup
							content="Dane podane w tej części formularza pojawią się na fakturach"
							trigger={<i className="icon-info"></i>}
						/>
					</h3>
					<div
						className={`m-form__field ${
							valData.receiver.receiverName === false ? "is--error" : ""
						}`}
					>
						<label>Nazwa</label>
						<div className="m-form__component ">
							<input
								type="text"
								data-pattern="^.{1,128}$"
								data-required
								placeholder="Pełna nazwa kontrahenta"
								name="receiver.receiverName"
								value={outputData.receiver.receiverName}
								onChange={(e) => {
									inputChange("receiver.receiverName", e.target.value);
								}}
								onBlur={(e) => {
									inputBlur(e.target, "receiver.receiverName");
								}}
							/>
						</div>
						<div className="m-form__component-error">
							{outputData.receiver.receiverName == ""
								? "Proszę uzupełnić pole"
								: "Prosze poprawić pole"}
						</div>
					</div>
					<div
						className={`m-form__field ${
							valData.receiver.receiverNIP == false ? "is--error" : ""
						}`}
					>
						<label>NIP</label>
						<div className="m-form__component">
							<InputMask
								mask="9999999999"
								data-pattern="NIP"
								data-required
								placeholder="Numer identyfikacji podatkowej Wnioskującego"
								name="receiver.receiverNIP"
								value={outputData.receiver.receiverNIP}
								onChange={(e) => {
									inputChange("receiver.receiverNIP", e.target.value);
								}}
								onBlur={(e) => {
									inputBlur(e.target, "receiver.receiverNIP");
								}}
							/>
						</div>
						<div className="m-form__component-error">
							{outputData.receiver.receiverNIP == ""
								? "Proszę uzupełnić pole"
								: "Prosze poprawić pole"}
						</div>
					</div>
					<div
						className={`m-form__field ${
							valData.receiver.receiverType == false ? "is--error" : ""
						}`}
					>
						<label>Rodzaj działalności</label>
						<Select
							options={receiverTypeOptions}
							placeholder="Wybierz rodzaj działalności"
							name="receiver.receiverType"
							value={outputData.receiver.receiverType}
							onChange={(e, { name, value }) => {
								inputChange(name, value);
							}}
						/>
					</div>
					{!(outputData.receiver.receiverType == 10) && (
						<>
							<div
								className={`m-form__field ${
									outputData.receiver.receiverRegisterPeriod === false ||
									outputData.receiver.receiverRegisterVat === false
										? "is--error"
										: ""
								}`}
							>
								<div className="m-form__field">
									<label className="with-tooltip">
										<span>
											Czy Firma jest zarejestrowana od min. 12 miesięcy?
										</span>
										<Popup trigger={<i className="icon-info"></i>} wide>
											<Grid columns={1}>
												<GridColumn>
													Program dostępny dla
													<ul>
														<li>- firm działających od min. 12 miesięcy,</li>
														<li>- zarejestrowanych jako podatnicy VAT</li>
													</ul>
												</GridColumn>
											</Grid>
										</Popup>
									</label>
								</div>

								<div className="m-form__field">
									<Radio
										label="Tak"
										value="true"
										checked={
											outputData.receiver.receiverRegisterPeriod === true
										}
										onChange={(e, { value }) =>
											handleRadioChange(
												e,
												{ value },
												"receiver.receiverRegisterPeriod"
											)
										}
									/>
								</div>
								<div className="m-form__field">
									<Radio
										label="Nie"
										value="false"
										checked={
											outputData.receiver.receiverRegisterPeriod === false
										}
										onChange={(e, { value }) =>
											handleRadioChange(
												e,
												{ value },
												"receiver.receiverRegisterPeriod"
											)
										}
									/>
								</div>

								<div className="m-form__field">
									<label className="with-tooltip">
										Czy podmiot jest zarejestrowanym podatnikiem VAT?
										<Popup trigger={<i className="icon-info"></i>} wide>
											<Grid columns={1}>
												<GridColumn>
													Program dostępny dla:
													<ul>
														<li>- firm działających od min. 12 miesięcy,</li>
														<li>- zarejestrowanych jako podatnicy VAT</li>
													</ul>
												</GridColumn>
											</Grid>
										</Popup>
									</label>
								</div>
								<div className="m-form__field">
									<Radio
										label="Tak"
										value="true"
										checked={outputData.receiver.receiverRegisterVat === true}
										onChange={(e, { value }) =>
											handleRadioChange(
												e,
												{ value },
												"receiver.receiverRegisterVat"
											)
										}
									/>
								</div>
								<div className="m-form__field">
									<Radio
										label="Nie"
										value="false"
										checked={outputData.receiver.receiverRegisterVat === false}
										onChange={(e, { value }) =>
											handleRadioChange(
												e,
												{ value },
												"receiver.receiverRegisterVat"
											)
										}
									/>
								</div>
								{(outputData.receiver.receiverRegisterPeriod === false ||
									outputData.receiver.receiverRegisterVat === false) && (
									<>
										<div className="m-form__component-error">
											Niestety, Twój wniosek nie może zostać rozpatrzony
											pozytywnie. Warunkiem przystąpienia do programu jest
											spełnienie obu powyższych założeń.
										</div>
									</>
								)}
							</div>
						</>
					)}
					<div
						className={`m-form__field ${
							valData.receiver.receiverAddress.street == false
								? "is--error"
								: ""
						}`}
					>
						<label>Ulica</label>
						<div className="m-form__component">
							<input
								type="text"
								placeholder=""
								name="receiver.receiverAddress.street"
								data-pattern="^.{1,128}$"
								data-required
								value={outputData.receiver.receiverAddress.street}
								onChange={(e) => {
									inputChange(
										"receiver.receiverAddress.street",
										e.target.value
									);
								}}
								onBlur={(e) => {
									inputBlur(e.target, "receiver.receiverAddress.street");
								}}
							/>
						</div>
						<div className="m-form__component-error">
							{outputData.receiver.receiverAddress.street == ""
								? "Proszę uzupełnić pole"
								: "Prosze poprawić pole"}
						</div>
					</div>
					<Grid columns={2}>
						<Grid.Row>
							<Grid.Column width={8}>
								<div
									className={`m-form__field ${
										valData.receiver.receiverAddress.houseNo == false
											? "is--error"
											: ""
									}`}
								>
									<label>Nr domu</label>
									<div className="m-form__component">
										<input
											type="text"
											placeholder=""
											name="receiver.receiverAddress.houseNo"
											data-pattern="^.{1,16}$"
											data-required
											value={outputData.receiver.receiverAddress.houseNo}
											onChange={(e) => {
												inputChange(
													"receiver.receiverAddress.houseNo",
													e.target.value
												);
											}}
											onBlur={(e) => {
												inputBlur(e.target, "receiver.receiverAddress.houseNo");
											}}
										/>
									</div>
									<div className="m-form__component-error">
										{outputData.receiver.receiverAddress.houseNo == ""
											? "Proszę uzupełnić pole"
											: "Prosze poprawić pole"}
									</div>
								</div>
							</Grid.Column>
							<Grid.Column width={8}>
								<div
									className={`m-form__field ${
										valData.receiver.receiverAddress.flatNo == false
											? "is--error"
											: ""
									}`}
								>
									<label>Nr mieszkania</label>
									<div className="m-form__component">
										<input
											type="text"
											placeholder=""
											name="receiver.receiverAddress.flatNo"
											data-pattern="^.{0,16}$"
											value={outputData.receiver.receiverAddress.flatNo}
											onChange={(e) => {
												inputChange(
													"receiver.receiverAddress.flatNo",
													e.target.value
												);
											}}
											onBlur={(e) => {
												inputBlur(e.target, "receiver.receiverAddress.flatNo");
											}}
										/>
									</div>
									<div className="m-form__component-error">
										{outputData.receiver.receiverAddress.flatNo == ""
											? "Proszę uzupełnić pole"
											: "Prosze poprawić pole"}
									</div>
								</div>
							</Grid.Column>
						</Grid.Row>
					</Grid>

					<div
						className={`m-form__field ${
							valData.receiver.receiverAddress.zipCode == false
								? "is--error"
								: ""
						}`}
					>
						<label>Kod pocztowy</label>
						<div className="m-form__component">
							<InputMask
								mask="99-999"
								placeholder="__-___"
								data-required
								data-pattern="\d{2}-\d{3}"
								name="receiver.receiverAddress.zipCode"
								value={outputData.receiver.receiverAddress.zipCode}
								onChange={(e) => {
									inputChange(
										"receiver.receiverAddress.zipCode",
										e.target.value
									);
								}}
								onBlur={(e) => {
									inputBlur(e.target, "receiver.receiverAddress.zipCode");
								}}
							/>
						</div>
						<div className="m-form__component-error">
							{outputData.receiver.receiverAddress.zipCode == ""
								? "Proszę uzupełnić pole"
								: "Prosze poprawić pole"}
						</div>
					</div>
					<div
						className={`m-form__field ${
							valData.receiver.receiverAddress.city == false ? "is--error" : ""
						}`}
					>
						<label>Miasto</label>
						<div className="m-form__component">
							<input
								type="text"
								placeholder="np. Warszawa"
								data-pattern="^.{1,64}$"
								data-required
								name="receiver.receiverAddress.city"
								value={outputData.receiver.receiverAddress.city}
								onChange={(e) => {
									inputChange("receiver.receiverAddress.city", e.target.value);
								}}
								onBlur={(e) => {
									inputBlur(e.target, "receiver.receiverAddress.city");
								}}
							/>
						</div>
						<div className="m-form__component-error">
							{outputData.receiver.receiverAddress.city == ""
								? "Proszę uzupełnić pole"
								: "Prosze poprawić pole"}
						</div>
					</div>
				</div>
				<div className="m-form__block">
					<h3 className="m-form__subheader">Reprezentacja</h3>
					{outputData.receiver.receiverRepresentatives.map((rep, index) => (
						<div className="m-form__group" key={"rep" + index}>
							<div
								className={`m-form__field ${
									valData.receiver.receiverRepresentatives[index]
										.representativeName == false
										? "is--error"
										: ""
								}`}
							>
								<label className="with-tooltip">
									<span>Imię i nazwisko pełnomocnika</span>
									<Popup
										content="Wnioskujący/Pełnomocnicy: podpisujący Umowę w imieniu Kontrahenta"
										trigger={<i className="icon-info"></i>}
									/>
								</label>
								<div className="m-form__component">
									<input
										type="text"
										placeholder="Imię"
										data-pattern="^.{1,64}$"
										data-required
										// name=''
										value={rep.representativeName}
										onChange={(e) => {
											inputChange(
												"receiver.receiverRepresentatives",
												e.target.value,
												index,
												"representativeName"
											);
										}}
										onBlur={(e) => {
											inputBlur(
												e.target,
												"receiver.receiverRepresentatives",
												index,
												"representativeName"
											);
										}}
									/>
								</div>
								<div className="m-form__component-error">
									{outputData.receiver.receiverRepresentatives[index]
										.representativeName == ""
										? "Proszę uzupełnić pole"
										: "Prosze poprawić pole"}
								</div>
							</div>
							<div
								className={`m-form__field ${
									valData.receiver.receiverRepresentatives[index]
										.representativeSurname == false
										? "is--error"
										: ""
								}`}
							>
								<div className="m-form__component">
									<input
										type="text"
										placeholder="Nazwisko"
										data-pattern="^.{1,64}$"
										data-required
										// name=''
										value={rep.representativeSurname}
										onChange={(e) => {
											inputChange(
												"receiver.receiverRepresentatives",
												e.target.value,
												index,
												"representativeSurname"
											);
										}}
										onBlur={(e) => {
											inputBlur(
												e.target,
												"receiver.receiverRepresentatives",
												index,
												"representativeSurname"
											);
										}}
									/>
								</div>
								<div className="m-form__component-error">
									{outputData.receiver.receiverRepresentatives[index]
										.representativeSurname == ""
										? "Proszę uzupełnić pole"
										: "Prosze poprawić pole"}
								</div>
							</div>
							{outputData.receiver.receiverType == 20 && (
								<>
									<div
										className={`m-form__field ${
											valData.receiver.receiverRepresentatives[index]
												.representativeID == false
												? "is--error"
												: ""
										}`}
									>
										<label>Numer dowodu osobistego</label>
										<div className="m-form__component">
											<InputMask
												mask="aaa999999"
												placeholder="nr dowodu osobistego osoby prowadzącej JDG (tylko w przypadku JDG)"
												data-required
												data-pattern="[a-zA-Z]{3}\d{6}"
												// name=''
												value={rep.representativeID}
												onChange={(e) => {
													inputChange(
														"receiver.receiverRepresentatives",
														e.target.value,
														index,
														"representativeID"
													);
												}}
												onBlur={(e) => {
													inputBlur(
														e.target,
														"receiver.receiverRepresentatives",
														index,
														"representativeID"
													);
												}}
											/>
										</div>
										<div className="m-form__component-error">
											{outputData.receiver.receiverRepresentatives[index]
												.representativeID == ""
												? "Proszę uzupełnić pole"
												: "Prosze poprawić pole"}
										</div>
									</div>
									<div
										className={`m-form__field ${
											valData.receiver.receiverRepresentatives[index]
												.representativePesel == false
												? "is--error"
												: ""
										}`}
									>
										<label>Pesel</label>
										<div className="m-form__component">
											<InputMask
												mask="99999999999"
												placeholder="nr PESEL osoby prowadzącej JDG (tylko w przypadku JDG)"
												data-required
												data-pattern="PESEL"
												// name=''
												value={rep.representativePesel}
												onChange={(e) => {
													inputChange(
														"receiver.receiverRepresentatives",
														e.target.value,
														index,
														"representativePesel"
													);
												}}
												onBlur={(e) => {
													inputBlur(
														e.target,
														"receiver.receiverRepresentatives",
														index,
														"representativePesel"
													);
												}}
											/>
										</div>
										<div className="m-form__component-error">
											{outputData.receiver.receiverRepresentatives[index]
												.representativePesel == ""
												? "Proszę uzupełnić pole"
												: "Prosze poprawić pole"}
										</div>
									</div>
								</>
							)}
							{/* {outputData.receiver.receiverType == 30 && (
                <div
                  className={`m-form__field ${
                    valData.receiver.receiverRepresentatives[index]
                      .representativePhone == false
                      ? "is--error"
                      : ""
                  }`}
                >
                  <label>
                    Telefon do jednorazowego kontaktu w celu potwierdzenia
                    szczegółów wniosku
                  </label>
                  <div className="m-form__component">
                    <InputMask
                      mask="48999999999"
                      placeholder=""
                      data-pattern="\d{11}"
                      data-required
                      // name=''
                      value={rep.representativePhone}
                      onChange={(e) => {
                        inputChange(
                          "receiver.receiverRepresentatives",
                          e.target.value,
                          index,
                          "representativePhone"
                        );
                      }}
                      onBlur={(e) => {
                        inputBlur(
                          e.target,
                          "receiver.receiverRepresentatives",
                          index,
                          "representativePhone"
                        );
                      }}
                    />
                  </div>
                  <div className="m-form__component-error">
                    {outputData.receiver.receiverRepresentatives[index]
                      .representativePhone == ""
                      ? "Proszę uzupełnić pole"
                      : "Prosze poprawić pole"}
                  </div>
                </div>
              )} */}
						</div>
					))}
					{outputData.receiver.receiverRepresentatives.length == 1 && (
						<button
							type="button"
							className="m-form__btn m-form__btn--light"
							onClick={addRepresentative}
						>
							<span>+ Dodaj kolejnego pełnomocnika</span> (opcjonalnie)
						</button>
					)}
					{outputData.receiver.receiverRepresentatives.length == 2 && (
						<button
							type="button"
							className="m-form__btn m-form__btn--light"
							onClick={removeRepresentative}
						>
							<span>- Usuń ostatniego pełnomocnika</span>
						</button>
					)}
				</div>
				<div className="m-form__block">
					<h3 className="m-form__subheader with-tooltip">
						<span>Nabywca</span>
						<Popup
							content="Jeżeli Nabywca jest różny od Odbiorcy, na fakturze Kontrahent pojawi się jako Odbiorca."
							trigger={<i className="icon-info"></i>}
						/>
					</h3>
					<div className="m-form__field">
						<Radio
							label="Ten sam co Wnioskujący"
							value="true"
							checked={outputData.buyer.sameAsReceiver === true}
							onChange={(e, { value }) =>
								handleRadioChange(e, { value }, "buyer.sameAsReceiver")
							}
						/>
					</div>
					<div className="m-form__field">
						<Radio
							label="Różny od Wnioskującego"
							value="false"
							checked={outputData.buyer.sameAsReceiver === false}
							onChange={(e, { value }) =>
								handleRadioChange(e, { value }, "buyer.sameAsReceiver")
							}
						/>
					</div>

					{!outputData.buyer.sameAsReceiver && (
						<>
							<div
								className={`m-form__field ${
									valData.buyer.buyerCompanyName == false ? "is--error" : ""
								}`}
							>
								<label>Nazwa</label>
								<div className="m-form__component">
									<input
										type="text"
										placeholder="Nazwa firmy"
										data-pattern="^.{1,64}$"
										data-required
										name="buyer.buyerCompanyName"
										value={outputData.buyer.buyerCompanyName}
										onChange={(e) => {
											inputChange("buyer.buyerCompanyName", e.target.value);
										}}
										onBlur={(e) => {
											inputBlur(e.target, "buyer.buyerCompanyName");
										}}
									/>
								</div>
								<div className="m-form__component-error">
									{outputData.buyer.buyerCompanyName == ""
										? "Proszę uzupełnić pole"
										: "Prosze poprawić pole"}
								</div>
							</div>
							<div
								className={`m-form__field ${
									valData.buyer.buyerNIP == false ? "is--error" : ""
								}`}
							>
								<label>NIP</label>
								<div className="m-form__component">
									<InputMask
										mask="9999999999"
										data-pattern="NIP"
										placeholder="Numer identyfikacji podatkowej Nabywcy"
										data-required
										name="buyer.buyerNIP"
										value={outputData.buyer.buyerNIP}
										onChange={(e) => {
											inputChange("buyer.buyerNIP", e.target.value);
										}}
										onBlur={(e) => {
											inputBlur(e.target, "buyer.buyerNIP");
										}}
									/>
								</div>
								<div className="m-form__component-error">
									{outputData.buyer.buyerNIP == ""
										? "Proszę uzupełnić pole"
										: "Prosze poprawić pole"}
								</div>
							</div>
							<div
								className={`m-form__field ${
									valData.buyer.buyerAddress.street == false ? "is--error" : ""
								}`}
							>
								<label>Ulica</label>
								<div className="m-form__component">
									<input
										type="text"
										placeholder=""
										data-pattern="^.{1,128}$"
										data-required
										name="buyer.buyerAddress.street"
										value={outputData.buyer.buyerAddress.street}
										onChange={(e) => {
											inputChange("buyer.buyerAddress.street", e.target.value);
										}}
										onBlur={(e) => {
											inputBlur(e.target, "buyer.buyerAddress.street");
										}}
									/>
								</div>
								<div className="m-form__component-error">
									{outputData.buyer.buyerAddress.street == ""
										? "Proszę uzupełnić pole"
										: "Prosze poprawić pole"}
								</div>
							</div>
							<Grid columns={2}>
								<Grid.Row>
									<Grid.Column width={8}>
										<div
											className={`m-form__field ${
												valData.buyer.buyerAddress.houseNo == false
													? "is--error"
													: ""
											}`}
										>
											<label>Nr domu</label>
											<div className="m-form__component">
												<input
													type="text"
													placeholder=""
													data-pattern="^.{1,16}$"
													data-required
													name="buyer.buyerAddress.houseNo"
													value={outputData.buyer.buyerAddress.houseNo}
													onChange={(e) => {
														inputChange(
															"buyer.buyerAddress.houseNo",
															e.target.value
														);
													}}
													onBlur={(e) => {
														inputBlur(e.target, "buyer.buyerAddress.houseNo");
													}}
												/>
											</div>
											<div className="m-form__component-error">
												{outputData.buyer.buyerAddress.houseNo == ""
													? "Proszę uzupełnić pole"
													: "Prosze poprawić pole"}
											</div>
										</div>
									</Grid.Column>
									<Grid.Column width={8}>
										<div
											className={`m-form__field ${
												valData.buyer.buyerAddress.flatNo == false
													? "is--error"
													: ""
											}`}
										>
											<label>Nr mieszkania</label>
											<div className="m-form__component">
												<input
													type="text"
													placeholder=""
													data-pattern="^.{0,16}$"
													name="buyer.buyerAddress.flatNo"
													value={outputData.buyer.buyerAddress.flatNo}
													onChange={(e) => {
														inputChange(
															"buyer.buyerAddress.flatNo",
															e.target.value
														);
													}}
													onBlur={(e) => {
														inputBlur(e.target, "buyer.buyerAddress.flatNo");
													}}
												/>
											</div>
											<div className="m-form__component-error">
												{outputData.buyer.buyerAddress.flatNo == ""
													? "Proszę uzupełnić pole"
													: "Prosze poprawić pole"}
											</div>
										</div>
									</Grid.Column>
								</Grid.Row>
							</Grid>

							<div
								className={`m-form__field ${
									valData.buyer.buyerAddress.zipCode == false ? "is--error" : ""
								}`}
							>
								<label>Kod pocztowy</label>
								<div className="m-form__component">
									<InputMask
										mask="99-999"
										placeholder="__-___"
										data-pattern="\d{2}-\d{3}"
										data-required
										name="buyer.buyerAddress.zipCode"
										value={outputData.buyer.buyerAddress.zipCode}
										onChange={(e) => {
											inputChange("buyer.buyerAddress.zipCode", e.target.value);
										}}
										onBlur={(e) => {
											inputBlur(e.target, "buyer.buyerAddress.zipCode");
										}}
									/>
								</div>
								<div className="m-form__component-error">
									{outputData.buyer.buyerAddress.zipCode == ""
										? "Proszę uzupełnić pole"
										: "Prosze poprawić pole"}
								</div>
							</div>
							<div
								className={`m-form__field ${
									valData.buyer.buyerAddress.city == false ? "is--error" : ""
								}`}
							>
								<label>Miasto</label>
								<div className="m-form__component">
									<input
										type="text"
										placeholder="np. Warszawa"
										data-pattern="^.{1,64}$"
										data-required
										name="buyer.buyerAddress.city"
										value={outputData.buyer.buyerAddress.city}
										onChange={(e) => {
											inputChange("buyer.buyerAddress.city", e.target.value);
										}}
										onBlur={(e) => {
											inputBlur(e.target, "buyer.buyerAddress.city");
										}}
									/>
								</div>
								<div className="m-form__component-error">
									{outputData.buyer.buyerAddress.city == ""
										? "Proszę uzupełnić pole"
										: "Prosze poprawić pole"}
								</div>
							</div>
							<div className={`m-form__field`}>
								<label>Nazwa płatnika (jeśli inny)</label>
								<div className="m-form__component">
									<input
										type="text"
										placeholder="Nazwa spółki obsługującej kontrahenta księgowo"
										name="buyer.buyerPayerName"
										value={outputData.buyer.buyerPayerName}
										onChange={(e) => {
											inputChange("buyer.buyerPayerName", e.target.value);
										}}
									/>
								</div>
							</div>
							<div className={`m-form__field`}>
								<label>Adres płatnika (jeśli inny)</label>
								<div className="m-form__component">
									<input
										type="text"
										placeholder="Adres spółki obsługującej kontrahenta księgowo"
										name="buyer.buyerPayerAddress"
										value={outputData.buyer.buyerPayerAddress}
										onChange={(e) => {
											inputChange("buyer.buyerPayerAddress", e.target.value);
										}}
									/>
								</div>
							</div>
						</>
					)}
				</div>
				<div className="m-form__block">
					<h3 className="m-form__subheader with-tooltip">
						<span>Składający wniosek</span>
						<Popup
							content="Dane osoby wypełniające wniosek na rzecz Kontrahenta"
							trigger={<i className="icon-info"></i>}
						/>
					</h3>
					<div
						className={`m-form__field ${
							valData.applicant.applicantName == false ? "is--error" : ""
						}`}
					>
						<label>Imię i nazwisko</label>
						<div className="m-form__component">
							<input
								type="text"
								placeholder=""
								data-pattern="^.{1,64}$"
								data-required
								name="applicant.applicantName"
								value={outputData.applicant.applicantName}
								onChange={(e) => {
									inputChange("applicant.applicantName", e.target.value);
								}}
								onBlur={(e) => {
									inputBlur(e.target, "applicant.applicantName");
								}}
							/>
						</div>
						<div className="m-form__component-error">
							{outputData.applicant.applicantName == ""
								? "Proszę uzupełnić pole"
								: "Prosze poprawić pole"}
						</div>
					</div>
					<div className={`m-form__field`}>
						<label>Funkcja lub Stanowisko (opcjonalnie)</label>
						<div className="m-form__component">
							<input
								type="text"
								placeholder=""
								name="applicant.applicantPosition"
								value={outputData.applicant.applicantPosition}
								onChange={(e) => {
									inputChange("applicant.applicantPosition", e.target.value);
								}}
							/>
						</div>
					</div>
					<div
						className={`m-form__field ${
							valData.applicant.applicantPhone == false ? "is--error" : ""
						}`}
					>
						<label>Numer telefonu</label>
						<div className="m-form__component">
							<InputMask
								mask="48999999999"
								placeholder=""
								data-pattern="\d{11}"
								data-required
								name="applicant.applicantPhone"
								value={outputData.applicant.applicantPhone}
								onChange={(e) => {
									inputChange("applicant.applicantPhone", e.target.value);
								}}
								onBlur={(e) => {
									inputBlur(e.target, "applicant.applicantPhone");
								}}
							/>
						</div>
						<div className="m-form__component-error">
							{outputData.applicant.applicantPhone == ""
								? "Proszę uzupełnić pole"
								: "Prosze poprawić pole"}
						</div>
					</div>
					<div
						className={`m-form__field ${
							valData.applicant.applicantEmail == false ? "is--error" : ""
						}`}
					>
						<label>Adres e-mail</label>
						<div className="m-form__component">
							<input
								type="email"
								placeholder=""
								data-pattern="[\w-\.]+@([\w-]+\.)+[\w-]{2,4}"
								data-required
								name="applicant.applicantEmail"
								value={outputData.applicant.applicantEmail}
								onChange={(e) => {
									inputChange("applicant.applicantEmail", e.target.value);
								}}
								onBlur={(e) => {
									inputBlur(e.target, "applicant.applicantEmail");
								}}
							/>
						</div>
						<div className="m-form__component-error">
							{outputData.applicant.applicantEmail == ""
								? "Proszę uzupełnić pole"
								: "Prosze poprawić pole"}
						</div>
					</div>
				</div>
				<div className="m-form__btns">
					<button
						type="submit"
						className="m-form__btn m-form__btn--next"
						disabled={!isValid}
					>
						Przejdź dalej
					</button>
					<button
						type="button"
						className="m-form__btn m-form__btn--back"
						onClick={() => {
							nextStep(0);
						}}
					>
						Powrót
					</button>
				</div>
			</form>
		</div>
	);
};
